import { render, staticRenderFns } from "./DoctorIcon.vue?vue&type=template&id=59429e29"
import script from "./DoctorIcon.vue?vue&type=script&lang=ts"
export * from "./DoctorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports